/* tslint:disable */

/**
 */
export class saveTempRecordPts {
    ID_STUDY?: number;
    ID_STUDY_EQUIPMENTS?: number;
    AXE?: number;
    NB_STEPS?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/save-temp-record-pts.ts